export default __webpack_public_path__ + "static/src/assets/images/icons/mobiles/sort_des_light@2x.png";